module.exports = __webpack_public_path__ + "01249fe245fb59f7f3d1840b4840c8a9.png";